module.exports = __webpack_public_path__ + "img/aboutAuthenticLabs.08ab108d.png";